import {
	ADD_DATA,
	DELETE_DATA,
	GET_ALL_DATA,
	UPDATE_DATA,
	GET_MENUS,
	DETAIL_DATA,
} from '@/api/master/role';
import querystring from 'query-string';

const state = {
	list: [],
	listMenus: [],
	isLoading: false,
	detail: {
		id: '',
		roles_name: '',
		description: '',
		menus: [],
	},
};

const mutations = {
	SET_LIST: (state, payload) => {
		state.list = payload;
	},
	SET_MENUS: (state, payload) => {
		state.listMenus = payload;
	},
	SET_DETAIL: (state, payload) => {
		state.detail = {
			id: payload.id,
			roles_name: payload.roles_name,
			description: payload.description,
			menus: payload.menus,
		};
	},
};

const actions = {
	GET_LIST: async ({ commit }, params) => {
		params = querystring.stringify(params);
		const resp = await GET_ALL_DATA(params);
		const data = resp.data.data;
		commit('SET_LIST', data);
	},

	GET_MENUS: async ({ commit }) => {
		const resp = await GET_MENUS();
		const data = resp.data.data;
		commit('SET_MENUS', data);
	},

	GET_DETAIL: async ({ commit }, id) => {
		const resp = await DETAIL_DATA({ id: id });
		const data = resp.data.data;
		commit('SET_DETAIL', data);
	},

	CREATE_DATA: async ({}, args) => {
		return await ADD_DATA(args);
	},
	UPDATE_DATA: async ({}, args) => {
		return await UPDATE_DATA(args);
	},

	DELETE_DATA: async ({}, id) => {
		console.log('delete id', id);
		return await DELETE_DATA(id);
	},
};

const getters = {
	list: (state) => state.list,
	listMenus: (state) => state.listMenus,
	detail: (state) => state.detail,
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
};
